import React from "react";
import Navbar from "../Components/Navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaStar } from "react-icons/fa6";

import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import { clients } from "../Components/Testimonial";
import Footer from "../Components/Footer";
import { FaCameraRetro } from "react-icons/fa";

const Testimonial = () => {
  return (
    <>
      {/* <Navbar /> */}
      <div className="testimonial bg-light py-5">
        <h5 className="text_maincolor text-center">Feedbacks</h5>
        <h1 className="display-6 text-center fw-600 amaranth-regular">
          Hear From Our Clients
        </h1>
        <Swiper
          style={{ marginTop: "3rem" }}
          className="mySwiper "
          slidesPerView={1}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
        >
          {clients.map((val, index) => (
            <SwiperSlide key={index} className="d-flex justify-content-center ">
              <div className="inner_con container">
                <div className="d-flex justify-content-center bg_maincolor text-white rounded-circle align-items-center mx-auto" style={{width:80,height:80}}>
                  <FaCameraRetro fontSize={30} />
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <h5 className="mb-0">{val.name}</h5>
                  <div className="text-center">
                    <div className="fs-14 text-muted">Country</div>
                    <strong className="text_maincolor">{val.country}</strong>
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-2 mt-3 text-warning">
                  {[...Array(5)].map((_, index) => (
                    <FaStar key={index} />
                  ))}
                </div>
                <p className="pt-3 text-center">{val.rewiew}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Testimonial;
